import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowRight, MessageCircle } from "lucide-react";
import { IMG, waLink } from "@/lib/site";
import { Reveal } from "@/components/Reveal";

export const QuoteCta = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section ref={ref} data-testid="quote-cta-section" className="relative w-full overflow-hidden grain">
      <motion.img style={{ y }} src={IMG.truckAutobahn} alt="" aria-hidden className="absolute inset-0 w-full h-[124%] object-cover" />
      <div className="absolute inset-0 bg-black/74" />
      <div className="relative z-10 w-full px-5 sm:px-8 lg:px-12 py-20 sm:py-28 lg:py-40">
        <Reveal>
          <span className="hazard-stripe block w-24 sm:w-28 h-[9px] mb-7" />
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="font-display uppercase font-black leading-[0.88] tracking-tight text-white text-[clamp(2.1rem,8vw,5.6rem)] max-w-[1400px]">
            Sie planen einen Transport<br />
            oder <span className="text-[#f95700]">Umzug?</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-6 text-[15px] sm:text-lg text-neutral-300 max-w-2xl leading-relaxed">
            Senden Sie uns Ihre Anfrage und erhalten Sie ein individuelles Angebot.
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <a
              href="#konfigurator"
              data-testid="cta-quote-button"
              className="group inline-flex items-center justify-between gap-5 bg-[#f95700] hover:bg-[#e04e00] text-white h-16 px-6 sm:pl-8 sm:pr-6 font-display text-lg sm:text-xl font-bold uppercase tracking-wide transition-colors clip-notch"
            >
              Transport anfragen
              <ArrowRight size={22} className="transition-transform duration-500 group-hover:translate-x-1.5" />
            </a>
            <a
              href={waLink("Hallo Global Move Europa, ich plane einen Transport bzw. Umzug und möchte ein Angebot erhalten.")}
              target="_blank"
              rel="noreferrer"
              data-testid="cta-whatsapp-button"
              className="group inline-flex items-center justify-between gap-5 border border-white/35 hover:border-white bg-white/5 backdrop-blur-md text-white h-16 px-6 sm:pl-8 sm:pr-6 font-display text-lg sm:text-xl font-bold uppercase tracking-wide transition-colors"
            >
              WhatsApp öffnen
              <MessageCircle size={22} className="text-[#25D366]" />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
